import type { Options } from "./Options";

export const DEFAULT_TIMEOUT_MS = 5000;

export const fromOptions = (
  opts: Options | null | undefined,
): [ReturnType<typeof setTimeout>, AbortSignal] => {
  const { timeout = DEFAULT_TIMEOUT_MS } = opts || {};
  const controller = new AbortController();
  const { signal } = controller;
  const timeoutId = setTimeout(() => controller.abort(), timeout);
  return [timeoutId, signal];
};
